import React from 'react';
// import { Xbtn } from 'src/assets/index';

function Popup(props) {
    const { noneBtn, text, btnNm, onClose } = { ...props };

    function handleOnClick(isCnfm) {
        onClose(isCnfm);
    }

    return (
        <div className="popUp-wrapper">
            <div className="popUp-container">
                <section className="popUp-box">
                    <div className='popUp-box-layout'>
                        {props.title && <p className='popUp-title cnfmPopup'>{props.title}</p>}
                        <p className={props.textLeft ? 'popUp-text' : 'popUp-text cnfmPopup'}>
                            {text.split("\n").map((txt, index) => (
                                <React.Fragment key={index}>
                                    {txt}
                                    <br />
                                </React.Fragment>
                            ))}
                        </p>
                        {/* {!props.btnDouble && <img src={Xbtn} alt="xbox" id="xbtn" onClick={handleOnClick} />} */}
                        { props.btnDouble 
                        ?
                            <div className="btnBox">
                            <>
                            <button type="button" className="btn btnOne btn-before" onClick={() => handleOnClick(false)}>아니오</button>
                            <button type="button" className="btn btnTwo btn-next" onClick={() => handleOnClick(true)}>예</button>
                            </>
                            </div>
                        : 
                        !noneBtn
                        ?
                            <div className="btnBox">
                            <>
                            <button type="button" className="btn btnTwo btnCnfm" onClick={handleOnClick}>{btnNm}</button>
                            </>
                            </div>
                        :
                            <></>
                        }
                    </div>
                </section>
            </div>
        </div>
    )
}

export default React.memo(Popup)